import React from 'react'

export const ActionButtonPrimary = ({ label, action = null }) => {
    return (
        <button
            onClick={action}
            style={{
                marginTop: '3rem',
                fontFamily: 'inter',
                width: '150px',
                height: '50px',
                padding: '10px',
                gap: '10px',
                border: '1px',
                fontSize: '0.8rem',
                background: '#2B4CC9',
                borderRadius: '4px',
                color: '#fff',
            }}>
            {label}
        </button>
    )
}